/* eslint-disable @typescript-eslint/no-explicit-any */
import { createReducer } from 'reduxsauce'

import { DuplicateNFTsTypes } from 'store/actions'
import { DUPLICATE_NFTS_INITIAL_STATE } from 'store/states'

/* ------------- Reducers ------------- */

export const resetDuplicateNftsData = (state: any) => {
  return {
    ...state,
    hasDataToLoad: true,
    collections: [],
  }
}

export const getDuplicateNftsData = (state: any, { payload }: any) => {
  const { loading } = payload
  return {
    ...state,
    loading,
    isRequesting: true,
  }
}

export const setDuplicateNftsData = (state: any, { payload }: any) => {
  const { collections, hasDataToLoad } = payload

  let newCollections: any = []
  if (!collections) {
    newCollections = [...state.collections]
  } else {
    newCollections = [...state.collections]
    collections.forEach((data: any) => {
      const exists = newCollections.find((d: any) => d.id === data.id)
      if (!exists) {
        newCollections.push(data)
      }
    })
  }

  return {
    ...state,
    hasDataToLoad,
    collections: newCollections,
    loading: false,
    isRequesting: false,
    hasInitialized: true,
  }
}

export const updateDuplicateNftsData = (state: any, { payload }: any) => {
  // eslint-disable-next-line camelcase
  const { params, id } = payload

  const updatedCollections = state.collections.map((data: any) => {
    if (data.id === id) {
      return { ...params, id }
    }

    return data
  })

  return {
    ...state,
    collections: updatedCollections,
    loading: false,
    isRequesting: false,
    hasInitialized: true,
  }
}

export const setDuplicateNftsActiveChain = (state: any, { payload }: any) => {
  return {
    ...state,
    activeChain: payload,
    collections: [],
    hasDataToLoad: true,
  }
}

/* ------------- Hookup Reducers To Types ------------- */

export const duplicateNFTsReducer = createReducer(DUPLICATE_NFTS_INITIAL_STATE, {
  // Mint Collection
  [DuplicateNFTsTypes.RESET_DUPLICATE_NFTS_DATA]: resetDuplicateNftsData,
  [DuplicateNFTsTypes.GET_DUPLICATE_NFTS_DATA]: getDuplicateNftsData,
  [DuplicateNFTsTypes.SET_DUPLICATE_NFTS_DATA]: setDuplicateNftsData,
  [DuplicateNFTsTypes.UPDATE_DUPLICATE_NFTS_DATA]: updateDuplicateNftsData,
  [DuplicateNFTsTypes.SET_DUPLICATE_NFTS_ACTIVE_CHAIN]: setDuplicateNftsActiveChain,
})
